type StatusType = 'pass' | 'warning' | 'fail' | 'info';

const labels: Record<StatusType, string> = {
  pass: 'Pass',
  warning: 'Warning',
  fail: 'Fail',
  info: 'Info',
};

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

/** Pill status badge with a coloured dot — ported from the IQ Verity prototype. */
const StatusBadge = ({ status, label, className = '' }: StatusBadgeProps) => (
  <span className={`vr-badge vr-badge-${status} ${className}`.trim()}>
    <span className="vr-dot" />
    {label || labels[status]}
  </span>
);

export default StatusBadge;
